/* Pet pillow builder add-on: Photoroom processing (via Cloudflare Worker) + photo enhancement.
   - Points the builder at the worker (old VPS stays as a fallback inside the worker).
   - Enhances the cut-out on the customer's device (lighting, levels, colour, clarity, sharpening).
   - Never lets the 3D engine download hang: 15 s timeout, then a backup CDN. */
(function () {
  'use strict';
  var API = 'https://pillow-api.reputationguruz.workers.dev';
  var ROOT = '[data-pp3d-v15-root]';
  var O = { light: 0.5, clar: 0.35, sharp: 0.7, sat: 1.03 };

  // Runs before the builder boots (both scripts are deferred), so the constructor picks up the new API.
  function setApi() {
    document.querySelectorAll(ROOT).forEach(function (r) { r.dataset.processingApi = API; });
  }
  setApi();

  async function enhance(blob) {
    try {
      var t0 = performance.now();
      var bmp = await createImageBitmap(blob);
      var sw = bmp.width, sh = bmp.height;
      // 1) find the pet on a small copy
      var k = Math.min(1, 800 / Math.max(sw, sh));
      var tw = Math.max(1, Math.round(sw * k)), th = Math.max(1, Math.round(sh * k));
      var tc = document.createElement('canvas'); tc.width = tw; tc.height = th;
      var tx = tc.getContext('2d', { willReadFrequently: true }); tx.drawImage(bmp, 0, 0, tw, th);
      var ta = tx.getImageData(0, 0, tw, th).data;
      var minX = tw, minY = th, maxX = -1, maxY = -1, x0, y0;
      for (y0 = 0; y0 < th; y0++) for (x0 = 0; x0 < tw; x0++) if (ta[(y0 * tw + x0) * 4 + 3] > 8) {
        if (x0 < minX) minX = x0; if (x0 > maxX) maxX = x0; if (y0 < minY) minY = y0; if (y0 > maxY) maxY = y0;
      }
      if (maxX < 0) return blob;
      var pad = 3;
      var cx = Math.max(0, Math.floor((minX - pad) / k)), cy = Math.max(0, Math.floor((minY - pad) / k));
      var cw = Math.min(sw - cx, Math.ceil((maxX - minX + 1 + 2 * pad) / k));
      var ch = Math.min(sh - cy, Math.ceil((maxY - minY + 1 + 2 * pad) / k));
      // 2) print size: longest side 2200-2800 px (max 2.5x upscale)
      var longest = Math.max(cw, ch), sc = 1;
      if (longest < 2200) sc = Math.min(2.5, 2200 / longest); else if (longest > 2800) sc = 2800 / longest;
      var w = Math.round(cw * sc), h = Math.round(ch * sc);
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      var x = c.getContext('2d', { willReadFrequently: true });
      x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
      x.drawImage(bmp, cx, cy, cw, ch, 0, 0, w, h);
      if (bmp.close) bmp.close();
      var blurOf = function (px) {
        var bc = document.createElement('canvas'); bc.width = w; bc.height = h;
        var bx = bc.getContext('2d', { willReadFrequently: true });
        bx.filter = 'blur(' + px.toFixed(1) + 'px)'; bx.drawImage(c, 0, 0); bx.filter = 'none';
        return bx.getImageData(0, 0, w, h).data;
      };
      var L = function (r, g, b) { return r * 0.299 + g * 0.587 + b * 0.114; };
      var id = x.getImageData(0, 0, w, h), d = id.data, i, v;
      // 3) tone: even out lighting + levels on brightness only, so colours stay natural (no yellow cast)
      var big = blurOf(Math.max(w, h) / 25);
      var hist = new Uint32Array(256), n = 0;
      for (i = 0; i < d.length; i += 4) if (d[i + 3] > 200) { hist[Math.min(255, L(d[i], d[i + 1], d[i + 2]) | 0)]++; n++; }
      var lo = 0, hi = 255, acc = 0;
      if (n) {
        for (v = 0; v < 256; v++) { acc += hist[v]; if (acc >= n * 0.004) { lo = v; break; } }
        acc = 0; for (v = 255; v >= 0; v--) { acc += hist[v]; if (acc >= n * 0.004) { hi = v; break; } }
      }
      lo = Math.min(lo, 30); hi = Math.max(hi, 225);
      for (i = 0; i < d.length; i += 4) {
        if (d[i + 3] === 0) continue;
        var l0 = L(d[i], d[i + 1], d[i + 2]), gain = 1;
        if (big[i + 3] >= 8) {
          // (canvas pixel data is already un-premultiplied, so no alpha division here)
          var base = L(big[i], big[i + 1], big[i + 2]) / 255;
          if (base < 0.5) gain = 1 + O.light * (0.5 - base) * 3;
          else if (base > 0.65) gain = 1 - O.light * (base - 0.65) * 1.2;
          gain = Math.min(1.6, Math.max(0.8, gain));
        }
        var l1 = Math.max(0, (l0 * gain - lo) * 255 / (hi - lo));
        var kf = l0 > 0.5 ? l1 / l0 : 1, mx = Math.max(d[i], d[i + 1], d[i + 2]);
        if (mx * kf > 255) kf = 255 / mx; // don't clip one channel (that would shift colours)
        var r = d[i] * kf, g = d[i + 1] * kf, b = d[i + 2] * kf, l = L(r, g, b);
        d[i] = l + (r - l) * O.sat; d[i + 1] = l + (g - l) * O.sat; d[i + 2] = l + (b - l) * O.sat;
      }
      x.putImageData(id, 0, 0);
      // 5) clarity + fine sharpening, inside the pet only (no halo on the outline)
      [[Math.max(w, h) / 180, O.clar, 3], [Math.max(1, Math.max(w, h) / 1400), O.sharp, 2]].forEach(function (p) {
        var bd = blurOf(p[0]);
        var id2 = x.getImageData(0, 0, w, h), e = id2.data;
        for (var j = 0; j < e.length; j += 4) {
          if (e[j + 3] < 250 || bd[j + 3] < 250) continue;
          for (var q = 0; q < 3; q++) { var diff = e[j + q] - bd[j + q]; if (diff > p[2] || diff < -p[2]) e[j + q] = e[j + q] + diff * p[1]; }
        }
        x.putImageData(id2, 0, 0);
      });
      // 6) clean the outline: soft edge pixels take the colour of the pet just inside them (no dark/yellow fringe)
      var eid = x.getImageData(0, 0, w, h), ed = eid.data;
      var core = document.createElement('canvas'); core.width = w; core.height = h;
      var kx = core.getContext('2d', { willReadFrequently: true });
      var cdat = kx.createImageData(w, h), cdd = cdat.data;
      for (i = 0; i < ed.length; i += 4) if (ed[i + 3] >= 250) { cdd[i] = ed[i]; cdd[i + 1] = ed[i + 1]; cdd[i + 2] = ed[i + 2]; cdd[i + 3] = 255; }
      kx.putImageData(cdat, 0, 0);
      var nb = document.createElement('canvas'); nb.width = w; nb.height = h;
      var nx = nb.getContext('2d', { willReadFrequently: true });
      nx.filter = 'blur(' + Math.max(3, Math.max(w, h) / 160).toFixed(1) + 'px)'; nx.drawImage(core, 0, 0); nx.filter = 'none';
      var nd = nx.getImageData(0, 0, w, h).data;
      for (i = 0; i < ed.length; i += 4) {
        if (ed[i + 3] === 0 || ed[i + 3] >= 250 || nd[i + 3] < 6) continue;
        ed[i] = nd[i]; ed[i + 1] = nd[i + 1]; ed[i + 2] = nd[i + 2];
      }
      x.putImageData(eid, 0, 0);
      var out = await new Promise(function (res) { c.toBlob(res, 'image/png'); });
      console.log('PP3D: photo enhanced in ' + Math.round(performance.now() - t0) + ' ms (' + w + 'x' + h + ')');
      return out || blob;
    } catch (err) {
      console.warn('PP3D: enhancement skipped', err);
      return blob; // never block the customer
    }
  }

  // Does the normal cut-out look messy? (pet lying on pillows/blankets: the cut-out runs off the
  // bottom and sides of the photo). Only then do we pay for the "pet only" cut-out.
  async function looksMessy(blob) {
    try {
      var bmp = await createImageBitmap(blob);
      var k = Math.min(1, 200 / Math.max(bmp.width, bmp.height));
      var w = Math.max(8, Math.round(bmp.width * k)), h = Math.max(8, Math.round(bmp.height * k));
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(bmp, 0, 0, w, h);
      if (bmp.close) bmp.close();
      var a = x.getImageData(0, 0, w, h).data, i, bottom = 0, left = 0, right = 0;
      for (i = 0; i < w; i++) if (a[((h - 1) * w + i) * 4 + 3] > 128) bottom++;
      for (i = 0; i < h; i++) { if (a[(i * w) * 4 + 3] > 128) left++; if (a[(i * w + w - 1) * 4 + 3] > 128) right++; }
      bottom /= w; left /= h; right /= h;
      var messy = (bottom > 0.4 && (left > 0.25 || right > 0.25)) || (left > 0.5 && right > 0.5);
      if (messy) console.log('PP3D: cut-out touches photo edges (bottom ' + bottom.toFixed(2) + ', left ' + left.toFixed(2) + ', right ' + right.toFixed(2) + ') - trying pet-only');
      return messy;
    } catch (e) { return false; }
  }

  async function petOnly(file) {
    try {
      var fd = new FormData(); fd.append('image', file, file.name || 'pet.jpg');
      var ctl = new AbortController(); var t = setTimeout(function () { ctl.abort(); }, 30000);
      var r = await fetch(API + '/api/process-pillow?mode=pet', { method: 'POST', body: fd, signal: ctl.signal, headers: { 'Accept': 'image/png' } });
      clearTimeout(t);
      if (!r.ok) return null;
      var b = await r.blob();
      // sanity check: the pet must still be there
      var bmp = await createImageBitmap(b);
      var k = Math.min(1, 200 / Math.max(bmp.width, bmp.height));
      var w = Math.max(8, Math.round(bmp.width * k)), h = Math.max(8, Math.round(bmp.height * k));
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(bmp, 0, 0, w, h);
      var a = x.getImageData(0, 0, w, h).data, n = 0;
      for (var i = 3; i < a.length; i += 4) if (a[i] > 128) n++;
      return n / (w * h) > 0.03 ? b : null;
    } catch (e) { return null; }
  }

  function loadEsmSh() {
    return Promise.all([
      import('https://esm.sh/three@0.179.1'),
      import('https://esm.sh/three@0.179.1/examples/jsm/controls/OrbitControls.js'),
      import('https://esm.sh/d3-contour@4.0.2'),
      import('https://esm.sh/three@0.179.1/examples/jsm/utils/BufferGeometryUtils.js')
    ]).then(function (m) {
      return { THREE: m[0], OrbitControls: m[1].OrbitControls, contours: m[2].contours, mergeVertices: m[3].mergeVertices,
        removeBackground: null, preloadBackground: null, pipeline: null, RawImage: null };
    });
  }

  function patch(inst) {
    if (!inst || inst.__ppPhotoroom) return;
    inst.__ppPhotoroom = true;
    inst.processingApi = API;

    var origProcess = inst.processImageOnServer.bind(inst);
    inst.processImageOnServer = function (file) {
      return origProcess(file).then(function (blob) {
        return looksMessy(blob).then(function (messy) {
          if (!messy) return blob;
          return petOnly(file).then(function (b2) { return b2 || blob; });
        });
      }).then(enhance);
    };

    // Pillow outline: round (distance-based) closing to bridge small gaps (legs, under the tail),
    // fill inner holes, then an even, rounded white sewing border around the whole pet.
    if (typeof inst.closeMask === 'function') {
      inst.closeMask = function (binary, w, h) {
        var INF = 1e9, N = w * h, i, x, y;
        function edt1(f, n, d, v, z) {
          var k = 0, q, s; v[0] = 0; z[0] = -INF; z[1] = INF;
          for (q = 1; q < n; q++) {
            s = ((f[q] + q * q) - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k]);
            while (s <= z[k]) { k--; s = ((f[q] + q * q) - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k]); }
            k++; v[k] = q; z[k] = s; z[k + 1] = INF;
          }
          k = 0; for (q = 0; q < n; q++) { while (z[k + 1] < q) k++; d[q] = (q - v[k]) * (q - v[k]) + f[v[k]]; }
        }
        function dist(t) { // squared distance from each pixel to the nearest pixel where t == 1
          var g = new Float64Array(N), n = Math.max(w, h), f = new Float64Array(n), d = new Float64Array(n),
            v = new Int32Array(n), z = new Float64Array(n + 1);
          for (i = 0; i < N; i++) g[i] = t[i] ? 0 : INF;
          for (x = 0; x < w; x++) { for (y = 0; y < h; y++) f[y] = g[y * w + x]; edt1(f, h, d, v, z); for (y = 0; y < h; y++) g[y * w + x] = d[y]; }
          for (y = 0; y < h; y++) { for (x = 0; x < w; x++) f[x] = g[y * w + x]; edt1(f, w, d, v, z); for (x = 0; x < w; x++) g[y * w + x] = d[x]; }
          return g;
        }
        var major = Math.max(w, h), rc = major * 0.035, ra = major * 0.022;
        var d1 = dist(binary), m = new Uint8Array(N), inv = new Uint8Array(N);
        for (i = 0; i < N; i++) { m[i] = d1[i] <= rc * rc ? 1 : 0; inv[i] = m[i] ? 0 : 1; }
        var d2 = dist(inv);
        for (i = 0; i < N; i++) {
          x = i % w; y = (i / w) | 0;
          var edge = Math.min(x + 1, y + 1, w - x, h - y);
          m[i] = (m[i] && d2[i] > rc * rc && edge > rc) || binary[i] ? 1 : 0;
        }
        var seen = new Uint8Array(N), st = [], idx;
        for (x = 0; x < w; x++) st.push(x, (h - 1) * w + x);
        for (y = 0; y < h; y++) st.push(y * w, y * w + w - 1);
        while (st.length) {
          idx = st.pop(); if (seen[idx] || m[idx]) continue; seen[idx] = 1; x = idx % w; y = (idx / w) | 0;
          if (x > 0) st.push(idx - 1); if (x < w - 1) st.push(idx + 1); if (y > 0) st.push(idx - w); if (y < h - 1) st.push(idx + w);
        }
        for (i = 0; i < N; i++) if (!m[i] && !seen[i]) m[i] = 1;
        var d3 = dist(m), out = new Uint8Array(N);
        for (i = 0; i < N; i++) out[i] = d3[i] <= ra * ra ? 1 : 0;
        return out;
      };
    }

    var origLoad = inst.loadModules.bind(inst);
    var fallbackP = null;
    inst.loadModules = function () {
      var self = this;
      if (self.modules) return Promise.resolve(self.modules);
      if (fallbackP) return fallbackP;
      var timer;
      var timeout = new Promise(function (_, rej) { timer = setTimeout(function () { rej(new Error('3D engine download timeout')); }, 15000); });
      return Promise.race([origLoad(), timeout]).then(function (m) { clearTimeout(timer); return m; }, function (err) {
        clearTimeout(timer);
        if (self.modules) return self.modules;
        console.warn('PP3D: 3D engine slow, switching to backup CDN', err);
        fallbackP = loadEsmSh().then(function (m) {
          // lock in one copy of the engine so a late download can't swap it mid-session
          Object.defineProperty(self, 'modules', { value: m, writable: false, configurable: true, enumerable: true });
          return m;
        }, function (e2) { fallbackP = null; throw e2; });
        return fallbackP;
      });
    };
  }

  function patchAll() {
    setApi();
    document.querySelectorAll(ROOT).forEach(function (r) { patch(r.__pp3dV15); });
  }
  patchAll();
  document.addEventListener('DOMContentLoaded', function () { setTimeout(patchAll, 0); });
  window.addEventListener('load', patchAll);
  document.addEventListener('shopify:section:load', function () { setTimeout(patchAll, 0); });
})();
